export default __webpack_public_path__ + "static/media/minus-icon.9a19baae.svg";